/* ═══════════════════════════════════════════════════
   BLOOMA V3 — JavaScript
   Parallax, hotspots, countdown, scroll reveal,
   analytics tracking
   ═══════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ─── 1. SCROLL REVEAL ───────────────────────────── */
  function initReveal() {
    var els = document.querySelectorAll('[data-v3-reveal], [data-v3-reveal-stagger]');
    if (!els.length) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('v3-revealed');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { obs.observe(el); });
  }

  /* ─── 2. HERO PARALLAX ──────────────────────────── */
  function initParallax() {
    var heroImg = document.querySelector('.hero-v3__main img');
    if (!heroImg) return;

    var ticking = false;
    var heroSection = heroImg.closest('.hero-v3');

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function () {
          var rect = heroSection.getBoundingClientRect();
          if (rect.bottom > 0 && rect.top < window.innerHeight) {
            var progress = -rect.top / window.innerHeight;
            heroImg.style.transform = 'scale(1.05) translateY(' + (progress * 30) + 'px)';
          }
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ─── 3. HOTSPOTS (Shop the Look) ───────────────── */
  function initHotspots() {
    var dots = document.querySelectorAll('.look-v3__dot');
    var cards = document.querySelectorAll('.look-v3__card');
    if (!dots.length) return;

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) {
        e.stopPropagation();
        var isActive = dot.classList.contains('active');

        /* Cerrar todos */
        dots.forEach(function (d) { d.classList.remove('active'); });
        cards.forEach(function (c) { c.classList.remove('active'); });

        /* Toggle el clickeado */
        if (!isActive && cards[i]) {
          dot.classList.add('active');
          cards[i].classList.add('active');

          /* Analytics */
          v3Track('hotspot_click', {
            product_name: cards[i].querySelector('.look-v3__card-name')?.textContent || '',
            hotspot_index: i
          });
        }
      });
    });

    /* Cerrar al hacer click fuera */
    document.addEventListener('click', function () {
      dots.forEach(function (d) { d.classList.remove('active'); });
      cards.forEach(function (c) { c.classList.remove('active'); });
    });
  }

  /* ─── 4. COUNTDOWN TIMER ─────────────────────────── */
  function initCountdown() {
    var el = document.getElementById('v3Countdown');
    if (!el) return;

    var target = el.getAttribute('data-target');
    if (!target) return;

    var targetDate = new Date(target).getTime();
    var daysEl = el.querySelector('[data-days]');
    var hoursEl = el.querySelector('[data-hours]');
    var minsEl = el.querySelector('[data-mins]');
    var secsEl = el.querySelector('[data-secs]');

    function update() {
      var now = Date.now();
      var diff = targetDate - now;

      if (diff <= 0) {
        if (daysEl) daysEl.textContent = '00';
        if (hoursEl) hoursEl.textContent = '00';
        if (minsEl) minsEl.textContent = '00';
        if (secsEl) secsEl.textContent = '00';
        return;
      }

      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);

      if (daysEl) daysEl.textContent = pad(d);
      if (hoursEl) hoursEl.textContent = pad(h);
      if (minsEl) minsEl.textContent = pad(m);
      if (secsEl) secsEl.textContent = pad(s);

      requestAnimationFrame(update);
    }

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    update();
  }

  /* ─── 5. SCROLL HORIZONTAL (Arrivals + BTS) ──────── */
  window.v3Scroll = function (selector, direction) {
    var container = document.querySelector(selector);
    if (!container) return;
    var firstChild = container.firstElementChild;
    if (!firstChild) return;
    var amount = firstChild.offsetWidth + 4;
    container.scrollBy({ left: direction * amount, behavior: 'smooth' });
  };

  /* ─── 6. NEWSLETTER (inline validation) ──────────── */
  function initNewsletter() {
    var form = document.getElementById('v3Newsletter');
    if (!form) return;

    var input = form.querySelector('.newsletter-v3__input');
    if (!input) return;

    input.addEventListener('input', function () {
      if (input.validity.typeMismatch) {
        input.style.borderColor = 'var(--error, #9e422c)';
      } else {
        input.style.borderColor = '';
      }
    });

    form.addEventListener('submit', function () {
      v3Track('newsletter_submit', { source: 'homepage_v3' });
    });
  }

  /* ─── 7. ANALYTICS — dataLayer helper ────────────── */
  function v3Track(event, data) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: event };
    if (data) {
      Object.keys(data).forEach(function (k) { payload[k] = data[k]; });
    }
    window.dataLayer.push(payload);
  }

  /* Analytics: section visibility tracking */
  function initSectionTracking() {
    var sections = document.querySelectorAll('[data-v3-track]');
    if (!sections.length) return;

    var tracked = {};
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var name = e.target.getAttribute('data-v3-track');
          if (!tracked[name]) {
            tracked[name] = true;
            v3Track('section_viewed', { section_name: name });
          }
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.25 });

    sections.forEach(function (el) { obs.observe(el); });
  }

  /* Analytics: scroll depth */
  function initScrollDepth() {
    var milestones = [25, 50, 75, 100];
    var reached = {};

    function check() {
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      var pct = Math.round((scrollTop / docHeight) * 100);

      milestones.forEach(function (m) {
        if (pct >= m && !reached[m]) {
          reached[m] = true;
          v3Track('scroll_depth', { depth: m + '%' });
        }
      });
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          check();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* Analytics: CTA clicks via data attributes */
  function initClickTracking() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-v3-click]');
      if (!btn) return;
      var eventName = btn.getAttribute('data-v3-click');
      var extra = btn.getAttribute('data-v3-click-data');
      var data = {};
      if (extra) {
        try { data = JSON.parse(extra); } catch (err) { /* ignorar */ }
      }
      v3Track(eventName, data);
    });
  }

  /* ─── 8. HERO CROSSFADE (reutilizado de V2) ──────── */
  function initHeroCrossfade() {
    var slides = document.querySelectorAll('#v3HeroSlides .hero-v3__slide');
    var dots = document.querySelectorAll('#v3HeroDots .hero-v3__dot');
    if (slides.length <= 1) return;

    var idx = 0;
    var interval = 5000;
    var timer;

    window.v3HeroSlide = function (target) {
      slides[idx].classList.remove('active');
      if (dots[idx]) dots[idx].classList.remove('active');
      idx = target;
      slides[idx].classList.add('active');
      if (dots[idx]) dots[idx].classList.add('active');
      clearInterval(timer);
      timer = setInterval(next, interval);
    };

    function next() {
      window.v3HeroSlide((idx + 1) % slides.length);
    }

    timer = setInterval(next, interval);
  }

  /* ─── INIT ───────────────────────────────────────── */
  function init() {
    initReveal();
    initParallax();
    initHotspots();
    initCountdown();
    initNewsletter();
    initHeroCrossfade();

    /* Analytics */
    initSectionTracking();
    initScrollDepth();
    initClickTracking();

    /* Page view */
    v3Track('view_homepage', { page_version: 'v3' });
  }

  /* Ejecutar cuando el DOM esté listo */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
